<div class="wrapper" [@fadeInOnEnter] [@fadeOutOnLeave]>
    <h2 class="box-title">
        Confirm mobile number associated with your vehicle
    </h2>
    <div class="radio-box">
        <mat-radio-group [formControl]="mdnControl" aria-labelledby="radio-group-label" class="radio-group">
            <mat-radio-button *ngFor="let mdn of mdnList" class="radio-button" [value]="mdn">
                {{mdn | mask: '(000) 000-0000'}}
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <app-main-button 
        [disabled]="!mdnControl.valid"
        (onClick)="onConfirm()"
        [buttonWidth]="'100%'"
        [border]="'1px solid #000000'"
        [textColor]="'#FFFFFF'"
        [backgroundColor]="'#000000'"
        [buttonText]="'Confirm'">
    </app-main-button>
</div>